export default {
  methods: {
    getDescription: (data) => {
      let str = ''
      for (let scope in data) {
        let sign = '-'
        if (scope === 'should') {
          sign = '+'
        }
        for (let kw of data[scope]) {
          str += sign + kw + ', '
        }
      }

      str = str.slice(0, -2)

      return str
    }
  },
  computed: {
    searches () {
      return this.$store.getters['search/searches']
    },
    activeSearch () {
      return this.$store.getters['search/active']
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js